/**
 * Utilities for operations on the local date.
 */
define([], () => ({
    /** Converts a jsDate into a DTO. */
    fromJSDate(jsDate) {
        return jsDate ? {'year': jsDate.getFullYear(), 'month': jsDate.getMonth(), 'day': jsDate.getDate()} : jsDate;
    },

    /** Converts a dto into a local midnight. */
    toLocalMidnight(dto) {
        return dto ? new Date(dto.year, dto.month, dto.day) : dto;
    },

    /** Converts a dto into a local noon time. */
    toLocalNoon(dto) {
        return dto ? new Date(dto.year, dto.month, dto.day, 12) : dto;
    }
}));


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/time/LocalDate.js
 **/